import { z } from 'zod';
import errors from '../errors';

export const registerSchema = (lang: 'en' | 'de') =>
  z
    .object({
      name: z
        .string()
        .min(2, errors.name_min[lang])
        .max(100, errors.name_max[lang]),
      device_token: z.string().optional().nullable(),
      address: z.object({
        street_name: z
          .string({ invalid_type_error: errors.required[lang] })
          .min(1, errors.required[lang]),
        house_number: z.string().min(1, errors.required[lang]),
        zip_code: z.string().optional().nullable(),
        city: z
          .string({ invalid_type_error: errors.required[lang] })
          .min(1, errors.required[lang]),
      }),
      restaurant_phone: z.string().regex(/^\d+$/, errors.phone[lang]),
      owner_first_name: z.string().min(1, errors.first_name_min[lang]),
      owner_last_name: z.string().min(1, errors.last_name_min[lang]),
      contact: z.object({
        phone: z.string().regex(/^\d+$/, errors.phone[lang]),
        first_name: z.string().min(1, errors.first_name_min[lang]),
        last_name: z.string().min(1, errors.last_name_min[lang]),
        password: z.string().min(1, errors.required[lang]),
        confirm_password: z.string().min(1, errors.required[lang]),
      }),
      email: z.string().email(errors.email[lang]),
      otp: z.coerce
        .number()
        .optional()
        .refine((value) => value && value >= 1000 && value <= 9999, {
          message: errors.otp[lang],
        }),
    })
    .refine((data) => data.contact.confirm_password === data.contact.password, {
      message: errors.password_mismatch[lang],
      path: ['contact.confirm_password'],
    });

export const registerOTPSchema = (lang: 'en' | 'de') =>
  z.object({
    contact: z.object({
      email: z.string().email({ message: errors.email[lang] }),
    }),
  });

export const loginSchema = (lang: 'en' | 'de') =>
  z.object({
    email: z.string().email({ message: errors.email[lang] }),
    password: z.string().min(8, errors.password[lang]),
  });

export const askQuestionsSchema = (lang: 'en' | 'de') =>
  z.object({
    website: z
      .string()
      .min(5, { message: 'website must be at least 5 characters' }),
    email: z.string().email({ message: errors.email[lang] }),
    mobile: z.string().min(10, { message: errors.phone[lang] }),
    message: z
      .string()
      .min(5, { message: 'Message must be at least 5 characters' }),
  });
